export const refs = {
  bodyEl: document.querySelector('body'),
  home: document.querySelector('.js-nav-home-btn'),
  library: document.querySelector('.js-nav-library-btn'),
  logo: document.querySelector('.js-logo-btn'),
  watched: document.querySelector('.js-btn-watched'),
  queue: document.querySelector('.js-btn-queue'),
  librarySection: document.querySelector('.library'),
  header: document.querySelector('.header'),
  btnOpenModalTeam: document.querySelector('.js-open-modal-team'),
  modalTeam: document.querySelector('.js-modal-team'),
  btnCloseModalTeam: document.querySelector('.js-close-modal-team'),
  formEl: document.querySelector('.form'),
  formInputEl: document.querySelector('.form__input'),
  formSelectGenreEl: document.querySelector('.form__select-genre'),
  galleryEl: document.querySelector('.gallery__container'),
  errorEl: document.querySelector('.search-error'),
  errorImgEl: document.querySelector('.errorImg__container'),
  emptyLibEl: document.querySelector('.errorImg__container--Library'),
  paginationContainer: document.getElementById('tui-pagination-container'),
  scrollToTopEl: document.querySelector('.scroll-to-top'),
  checkbox: document.querySelector('#switch'),
  toggler: document.querySelector('.toggler'),
  textToggler: document.querySelector('.text'),
  switchTheme: document.querySelector('#switchTheme'),
  iconTheme: document.querySelector('.checkbox__text'),
  iconGitHub: document.querySelector('.footer__icon-github'),
  footer: document.querySelector('.footer'),
};
